var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navMenu'),_c('hero',{attrs:{"heroTitle":_vm.$t('registerPage.title')}}),_c('registerForm'),_c('featured'),_c('footerJSK')],1)}
var staticRenderFns = []

export { render, staticRenderFns }